import { useNavigate } from "react-router-dom";
import { Box, Button, FormControlLabel, Radio, RadioGroup, Tab, Tabs, TextField, } from "@mui/material";
import React from "react";
import EmailTemplate from "./emailTemplate";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageSystemSettings = () => {

  const navigate = useNavigate();
  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  return (
    <>
      <div className="main_title">
        <h1>System Settings</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - System Settings
        </p>
      </div>
      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Global Controls" {...a11yProps(0)} />
              <Tab label="Email Template Editor" {...a11yProps(1)} />
            </Tabs>
          </Box>
        </div>
      </div>
      <div className="cards">
        <CustomTabPanel value={valueTabs} index={0}>
          <form className="form" action="">
            <div className="gap_p">
              <div className="control_group w_50">
                <label htmlFor="setting_maxVouchers">Maximum Vouchers per User per Reward</label>
                <TextField
                  id="setting_maxVouchers"
                  placeholder="Enter Maximum Vouchers"
                  type="number"
                  fullWidth
                  hiddenLabel
                />
              </div>
              <div className="control_group w_50">
                <label htmlFor="setting_expiration">Default Expiration Period for Points (days)</label>
                <TextField
                  id="setting_expiration"
                  placeholder="Enter Default Expiration Period for Points"
                  type="number"
                  fullWidth
                  hiddenLabel
                />
              </div>
              <div className="control_group">
                <label htmlFor="setting_referral">Referral Earning Method</label>
                <RadioGroup
                  className="flex"
                  aria-labelledby="demo-radio-Referral-group-label"
                  defaultValue="register"
                  name="radio-Referral-group"
                >
                  <FormControlLabel
                    value="register"
                    control={<Radio />}
                    label="On Register"
                  />
                  <FormControlLabel
                    value="firstPurchase"
                    control={<Radio />}
                    label="On First Purchase"
                  />
                </RadioGroup>
              </div>
            </div>
            <div className="form_btn">
              <Button className="btn btn_primary">Submit</Button>
            </div>
          </form>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <EmailTemplate />
        </CustomTabPanel>
      </div>
    </>
  );
};

export default ManageSystemSettings;
